import React from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_prism-drop/artifacts/p0emyz4e_A1D7B4C2-09C7-4121-907C-32B19B4042A4.PNG";
const WHATSAPP_HREF = "https://wa.me/393520463627";
const YOUTUBE_HREF = "https://www.youtube.com/channel/UCs68SjdTp0KWzMEiKiHy1sw";
const INSTAGRAM_HREF =
  "https://www.instagram.com/garagedrops?stkn=Nmx4cTIyNmtna3dz&utm_source=qr";

/**
 * Footer minimale, nero: servizi, link, WhatsApp, Instagram, YouTube, Privacy.
 * WhatsApp, Instagram, Privacy. Nessun form, nessun account.
 */
export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith("/vault-9821")) return null;

  return (
    <footer style={{ background: "#000000", color: "#8a8a8a" }} data-testid="footer">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10 pt-16 pb-10">
        <p className="text-[12px] leading-relaxed mb-10 max-w-2xl" style={{ color: "#6a6a6a" }}>
          Video, montaggio, fotografia e storytelling per ogni tua idea. E un piccolo marketplace di auto e moto che amiamo.
        </p>

        <div className="grid gap-10 sm:grid-cols-3 mb-14">
          <div>
            <img src={LOGO_URL} alt="Garage Drops" className="h-9 w-auto mb-4" />
            <div className="text-[13px]" style={{ color: "#8a8a8a" }}>Brescia · Italia</div>
          </div>
          <div className="flex flex-col gap-3">
            <Link to="/servizi" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-servizi">Servizi</Link>
            <Link to="/auto" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-auto">Marketplace · Auto</Link>
            <Link to="/moto" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-moto">Marketplace · Moto</Link>
            <Link to="/cinema" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-cinema">Video YouTube</Link>
            <Link to="/giornale" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-giornale">Articoli</Link>
            <Link to="/chi-siamo" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-chi-siamo">Team</Link>
          </div>
          <div className="flex flex-col gap-3">
            <a href={WHATSAPP_HREF} target="_blank" rel="noreferrer" className="text-[14px]" style={{ color: "#25D366" }} data-testid="footer-link-wa">
              WhatsApp · +39 352 046 3627
            </a>
            <a href={INSTAGRAM_HREF} target="_blank" rel="noreferrer" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-ig">
              Instagram
            </a>
            <a href={YOUTUBE_HREF} target="_blank" rel="noreferrer" className="text-[14px]" style={{ color: "#FFFFFF" }} data-testid="footer-link-yt">
              YouTube
            </a>
            <Link to="/privacy" className="text-[13px]" style={{ color: "#6a6a6a" }} data-testid="footer-link-privacy">Privacy</Link>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
          <div className="text-[12px]" style={{ color: "#6a6a6a" }}>© {new Date().getFullYear()} Garage Drops · Brescia</div>
          <div className="text-[12px]" style={{ color: "#6a6a6a" }}>Video · Foto · Storytelling · Marketing</div>
        </div>
      </div>
    </footer>
  );
}
